/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AnnotateCapturesRequest,
    AnnotateCapturesRequestFromJSON,
    AnnotateCapturesRequestToJSON,
} from '../models/AnnotateCapturesRequest';
import {
    type AnnotateCapturesResponse,
    AnnotateCapturesResponseFromJSON,
    AnnotateCapturesResponseToJSON,
} from '../models/AnnotateCapturesResponse';
import {
    type ComputeLengthRequest,
    ComputeLengthRequestFromJSON,
    ComputeLengthRequestToJSON,
} from '../models/ComputeLengthRequest';
import {
    type ComputeLengthResponse,
    ComputeLengthResponseFromJSON,
    ComputeLengthResponseToJSON,
} from '../models/ComputeLengthResponse';
import {
    type ComputeSpeciesRequest,
    ComputeSpeciesRequestFromJSON,
    ComputeSpeciesRequestToJSON,
} from '../models/ComputeSpeciesRequest';
import {
    type ComputeSpeciesResponse,
    ComputeSpeciesResponseFromJSON,
    ComputeSpeciesResponseToJSON,
} from '../models/ComputeSpeciesResponse';
import {
    type ConfirmCaptureMediaRequest,
    ConfirmCaptureMediaRequestFromJSON,
    ConfirmCaptureMediaRequestToJSON,
} from '../models/ConfirmCaptureMediaRequest';
import {
    type ConfirmCaptureMediaResponse,
    ConfirmCaptureMediaResponseFromJSON,
    ConfirmCaptureMediaResponseToJSON,
} from '../models/ConfirmCaptureMediaResponse';
import {
    type CreateCaptureLabelRequest,
    CreateCaptureLabelRequestFromJSON,
    CreateCaptureLabelRequestToJSON,
} from '../models/CreateCaptureLabelRequest';
import {
    type CreateCaptureLabelResponse,
    CreateCaptureLabelResponseFromJSON,
    CreateCaptureLabelResponseToJSON,
} from '../models/CreateCaptureLabelResponse';
import {
    type CreateManualCaptureRequest,
    CreateManualCaptureRequestFromJSON,
    CreateManualCaptureRequestToJSON,
} from '../models/CreateManualCaptureRequest';
import {
    type CreateManualCaptureResponse,
    CreateManualCaptureResponseFromJSON,
    CreateManualCaptureResponseToJSON,
} from '../models/CreateManualCaptureResponse';
import {
    type DeleteCaptureLabelRequest,
    DeleteCaptureLabelRequestFromJSON,
    DeleteCaptureLabelRequestToJSON,
} from '../models/DeleteCaptureLabelRequest';
import {
    type GetCapturesRequest,
    GetCapturesRequestFromJSON,
    GetCapturesRequestToJSON,
} from '../models/GetCapturesRequest';
import {
    type GetCapturesResponse,
    GetCapturesResponseFromJSON,
    GetCapturesResponseToJSON,
} from '../models/GetCapturesResponse';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';
import {
    type LinkCapturesRequest,
    LinkCapturesRequestFromJSON,
    LinkCapturesRequestToJSON,
} from '../models/LinkCapturesRequest';
import {
    type LinkCapturesResponse,
    LinkCapturesResponseFromJSON,
    LinkCapturesResponseToJSON,
} from '../models/LinkCapturesResponse';
import {
    type ListCaptureLabelsResponse,
    ListCaptureLabelsResponseFromJSON,
    ListCaptureLabelsResponseToJSON,
} from '../models/ListCaptureLabelsResponse';
import {
    type ListCapturesRequest,
    ListCapturesRequestFromJSON,
    ListCapturesRequestToJSON,
} from '../models/ListCapturesRequest';
import {
    type ListCapturesResponse,
    ListCapturesResponseFromJSON,
    ListCapturesResponseToJSON,
} from '../models/ListCapturesResponse';
import {
    type PresignCaptureMediaRequest,
    PresignCaptureMediaRequestFromJSON,
    PresignCaptureMediaRequestToJSON,
} from '../models/PresignCaptureMediaRequest';
import {
    type PresignCaptureMediaResponse,
    PresignCaptureMediaResponseFromJSON,
    PresignCaptureMediaResponseToJSON,
} from '../models/PresignCaptureMediaResponse';
import {
    type SetCaptureLabelRequest,
    SetCaptureLabelRequestFromJSON,
    SetCaptureLabelRequestToJSON,
} from '../models/SetCaptureLabelRequest';
import {
    type SetCaptureLabelResponse,
    SetCaptureLabelResponseFromJSON,
    SetCaptureLabelResponseToJSON,
} from '../models/SetCaptureLabelResponse';
import {
    type UpdateCaptureLabelRequest,
    UpdateCaptureLabelRequestFromJSON,
    UpdateCaptureLabelRequestToJSON,
} from '../models/UpdateCaptureLabelRequest';
import {
    type UpdateCaptureLabelResponse,
    UpdateCaptureLabelResponseFromJSON,
    UpdateCaptureLabelResponseToJSON,
} from '../models/UpdateCaptureLabelResponse';

export interface AnnotateCapturesOperationRequest {
    /**
     * 
     */
    annotateCapturesRequest: AnnotateCapturesRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ComputeLengthOperationRequest {
    /**
     * 
     */
    computeLengthRequest: ComputeLengthRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ComputeSpeciesOperationRequest {
    /**
     * 
     */
    computeSpeciesRequest: ComputeSpeciesRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ConfirmCaptureMediaOperationRequest {
    /**
     * 
     */
    confirmCaptureMediaRequest: ConfirmCaptureMediaRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface CreateCaptureLabelOperationRequest {
    /**
     * 
     */
    createCaptureLabelRequest: CreateCaptureLabelRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface CreateManualCaptureOperationRequest {
    /**
     * 
     */
    createManualCaptureRequest: CreateManualCaptureRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface DeleteCaptureLabelOperationRequest {
    /**
     * 
     */
    deleteCaptureLabelRequest: DeleteCaptureLabelRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface GetCapturesOperationRequest {
    /**
     * 
     */
    getCapturesRequest: GetCapturesRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface LinkCapturesOperationRequest {
    /**
     * 
     */
    linkCapturesRequest: LinkCapturesRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ListCaptureLabelsRequest {
    /**
     * 
     */
    body: object;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ListCapturesOperationRequest {
    /**
     * 
     */
    listCapturesRequest: ListCapturesRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface PresignCaptureMediaOperationRequest {
    /**
     * 
     */
    presignCaptureMediaRequest: PresignCaptureMediaRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface SetCaptureLabelOperationRequest {
    /**
     * 
     */
    setCaptureLabelRequest: SetCaptureLabelRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface UpdateCaptureLabelOperationRequest {
    /**
     * 
     */
    updateCaptureLabelRequest: UpdateCaptureLabelRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

/**
 * 
 */
export class CapturesApi extends runtime.BaseAPI {

    /**
     * Creates request options for annotateCaptures without sending the request
     */
    async annotateCapturesRequestOpts(requestParameters: AnnotateCapturesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['annotateCapturesRequest'] == null) {
            throw new runtime.RequiredError(
                'annotateCapturesRequest',
                'Required parameter "annotateCapturesRequest" was null or undefined when calling annotateCaptures().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/annotate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnnotateCapturesRequestToJSON(requestParameters['annotateCapturesRequest']),
        };
    }

    /**
     * Annotate Captures
     */
    async annotateCapturesRaw(requestParameters: AnnotateCapturesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnnotateCapturesResponse>> {
        const requestOptions = await this.annotateCapturesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnnotateCapturesResponseFromJSON(jsonValue));
    }

    /**
     * Annotate Captures
     */
    async annotateCaptures(requestParameters: AnnotateCapturesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnnotateCapturesResponse> {
        const response = await this.annotateCapturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for computeLength without sending the request
     */
    async computeLengthRequestOpts(requestParameters: ComputeLengthOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['computeLengthRequest'] == null) {
            throw new runtime.RequiredError(
                'computeLengthRequest',
                'Required parameter "computeLengthRequest" was null or undefined when calling computeLength().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/compute-length`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ComputeLengthRequestToJSON(requestParameters['computeLengthRequest']),
        };
    }

    /**
     * Trigger the server-side (Fishial) length recompute for an explicit list of captures, or all KEEP-triaged captures when `all_keeps` is set. Fires one fire-and-forget compute-length Prefect run per capture (idempotent).
     * Compute Length
     */
    async computeLengthRaw(requestParameters: ComputeLengthOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComputeLengthResponse>> {
        const requestOptions = await this.computeLengthRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComputeLengthResponseFromJSON(jsonValue));
    }

    /**
     * Trigger the server-side (Fishial) length recompute for an explicit list of captures, or all KEEP-triaged captures when `all_keeps` is set. Fires one fire-and-forget compute-length Prefect run per capture (idempotent).
     * Compute Length
     */
    async computeLength(requestParameters: ComputeLengthOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComputeLengthResponse> {
        const response = await this.computeLengthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for computeSpecies without sending the request
     */
    async computeSpeciesRequestOpts(requestParameters: ComputeSpeciesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['computeSpeciesRequest'] == null) {
            throw new runtime.RequiredError(
                'computeSpeciesRequest',
                'Required parameter "computeSpeciesRequest" was null or undefined when calling computeSpecies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/compute-species`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ComputeSpeciesRequestToJSON(requestParameters['computeSpeciesRequest']),
        };
    }

    /**
     * Trigger the server-side (Fishial) species classification for an explicit list of captures, or all KEEP-triaged captures when `all_keeps` is set. Fires one fire-and-forget compute-species Prefect run per capture (idempotent).
     * Compute Species
     */
    async computeSpeciesRaw(requestParameters: ComputeSpeciesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComputeSpeciesResponse>> {
        const requestOptions = await this.computeSpeciesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComputeSpeciesResponseFromJSON(jsonValue));
    }

    /**
     * Trigger the server-side (Fishial) species classification for an explicit list of captures, or all KEEP-triaged captures when `all_keeps` is set. Fires one fire-and-forget compute-species Prefect run per capture (idempotent).
     * Compute Species
     */
    async computeSpecies(requestParameters: ComputeSpeciesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComputeSpeciesResponse> {
        const response = await this.computeSpeciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for confirmCaptureMedia without sending the request
     */
    async confirmCaptureMediaRequestOpts(requestParameters: ConfirmCaptureMediaOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['confirmCaptureMediaRequest'] == null) {
            throw new runtime.RequiredError(
                'confirmCaptureMediaRequest',
                'Required parameter "confirmCaptureMediaRequest" was null or undefined when calling confirmCaptureMedia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/media/confirm`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmCaptureMediaRequestToJSON(requestParameters['confirmCaptureMediaRequest']),
        };
    }

    /**
     * Confirm Capture Media
     */
    async confirmCaptureMediaRaw(requestParameters: ConfirmCaptureMediaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfirmCaptureMediaResponse>> {
        const requestOptions = await this.confirmCaptureMediaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfirmCaptureMediaResponseFromJSON(jsonValue));
    }

    /**
     * Confirm Capture Media
     */
    async confirmCaptureMedia(requestParameters: ConfirmCaptureMediaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfirmCaptureMediaResponse> {
        const response = await this.confirmCaptureMediaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createCaptureLabel without sending the request
     */
    async createCaptureLabelRequestOpts(requestParameters: CreateCaptureLabelOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createCaptureLabelRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaptureLabelRequest',
                'Required parameter "createCaptureLabelRequest" was null or undefined when calling createCaptureLabel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture-label/create`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaptureLabelRequestToJSON(requestParameters['createCaptureLabelRequest']),
        };
    }

    /**
     * Create Capture Label
     */
    async createCaptureLabelRaw(requestParameters: CreateCaptureLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCaptureLabelResponse>> {
        const requestOptions = await this.createCaptureLabelRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCaptureLabelResponseFromJSON(jsonValue));
    }

    /**
     * Create Capture Label
     */
    async createCaptureLabel(requestParameters: CreateCaptureLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCaptureLabelResponse> {
        const response = await this.createCaptureLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createManualCapture without sending the request
     */
    async createManualCaptureRequestOpts(requestParameters: CreateManualCaptureOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createManualCaptureRequest'] == null) {
            throw new runtime.RequiredError(
                'createManualCaptureRequest',
                'Required parameter "createManualCaptureRequest" was null or undefined when calling createManualCapture().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/create`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateManualCaptureRequestToJSON(requestParameters['createManualCaptureRequest']),
        };
    }

    /**
     * Create Manual Capture
     */
    async createManualCaptureRaw(requestParameters: CreateManualCaptureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateManualCaptureResponse>> {
        const requestOptions = await this.createManualCaptureRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateManualCaptureResponseFromJSON(jsonValue));
    }

    /**
     * Create Manual Capture
     */
    async createManualCapture(requestParameters: CreateManualCaptureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateManualCaptureResponse> {
        const response = await this.createManualCaptureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteCaptureLabel without sending the request
     */
    async deleteCaptureLabelRequestOpts(requestParameters: DeleteCaptureLabelOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deleteCaptureLabelRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteCaptureLabelRequest',
                'Required parameter "deleteCaptureLabelRequest" was null or undefined when calling deleteCaptureLabel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture-label/delete`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteCaptureLabelRequestToJSON(requestParameters['deleteCaptureLabelRequest']),
        };
    }

    /**
     * Delete Capture Label
     */
    async deleteCaptureLabelRaw(requestParameters: DeleteCaptureLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteCaptureLabelRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Capture Label
     */
    async deleteCaptureLabel(requestParameters: DeleteCaptureLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCaptureLabelRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getCaptures without sending the request
     */
    async getCapturesRequestOpts(requestParameters: GetCapturesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['getCapturesRequest'] == null) {
            throw new runtime.RequiredError(
                'getCapturesRequest',
                'Required parameter "getCapturesRequest" was null or undefined when calling getCaptures().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/get`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetCapturesRequestToJSON(requestParameters['getCapturesRequest']),
        };
    }

    /**
     * Get Captures
     */
    async getCapturesRaw(requestParameters: GetCapturesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCapturesResponse>> {
        const requestOptions = await this.getCapturesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCapturesResponseFromJSON(jsonValue));
    }

    /**
     * Get Captures
     */
    async getCaptures(requestParameters: GetCapturesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCapturesResponse> {
        const response = await this.getCapturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for linkCaptures without sending the request
     */
    async linkCapturesRequestOpts(requestParameters: LinkCapturesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['linkCapturesRequest'] == null) {
            throw new runtime.RequiredError(
                'linkCapturesRequest',
                'Required parameter "linkCapturesRequest" was null or undefined when calling linkCaptures().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/link`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkCapturesRequestToJSON(requestParameters['linkCapturesRequest']),
        };
    }

    /**
     * Link Captures
     */
    async linkCapturesRaw(requestParameters: LinkCapturesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkCapturesResponse>> {
        const requestOptions = await this.linkCapturesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkCapturesResponseFromJSON(jsonValue));
    }

    /**
     * Link Captures
     */
    async linkCaptures(requestParameters: LinkCapturesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkCapturesResponse> {
        const response = await this.linkCapturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listCaptureLabels without sending the request
     */
    async listCaptureLabelsRequestOpts(requestParameters: ListCaptureLabelsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling listCaptureLabels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture-label/list`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * List Capture Labels
     */
    async listCaptureLabelsRaw(requestParameters: ListCaptureLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCaptureLabelsResponse>> {
        const requestOptions = await this.listCaptureLabelsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCaptureLabelsResponseFromJSON(jsonValue));
    }

    /**
     * List Capture Labels
     */
    async listCaptureLabels(requestParameters: ListCaptureLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCaptureLabelsResponse> {
        const response = await this.listCaptureLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listCaptures without sending the request
     */
    async listCapturesRequestOpts(requestParameters: ListCapturesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['listCapturesRequest'] == null) {
            throw new runtime.RequiredError(
                'listCapturesRequest',
                'Required parameter "listCapturesRequest" was null or undefined when calling listCaptures().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/list`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListCapturesRequestToJSON(requestParameters['listCapturesRequest']),
        };
    }

    /**
     * List Captures
     */
    async listCapturesRaw(requestParameters: ListCapturesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCapturesResponse>> {
        const requestOptions = await this.listCapturesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCapturesResponseFromJSON(jsonValue));
    }

    /**
     * List Captures
     */
    async listCaptures(requestParameters: ListCapturesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCapturesResponse> {
        const response = await this.listCapturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for presignCaptureMedia without sending the request
     */
    async presignCaptureMediaRequestOpts(requestParameters: PresignCaptureMediaOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['presignCaptureMediaRequest'] == null) {
            throw new runtime.RequiredError(
                'presignCaptureMediaRequest',
                'Required parameter "presignCaptureMediaRequest" was null or undefined when calling presignCaptureMedia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/media/presign`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PresignCaptureMediaRequestToJSON(requestParameters['presignCaptureMediaRequest']),
        };
    }

    /**
     * Presign Capture Media
     */
    async presignCaptureMediaRaw(requestParameters: PresignCaptureMediaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresignCaptureMediaResponse>> {
        const requestOptions = await this.presignCaptureMediaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresignCaptureMediaResponseFromJSON(jsonValue));
    }

    /**
     * Presign Capture Media
     */
    async presignCaptureMedia(requestParameters: PresignCaptureMediaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresignCaptureMediaResponse> {
        const response = await this.presignCaptureMediaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setCaptureLabel without sending the request
     */
    async setCaptureLabelRequestOpts(requestParameters: SetCaptureLabelOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['setCaptureLabelRequest'] == null) {
            throw new runtime.RequiredError(
                'setCaptureLabelRequest',
                'Required parameter "setCaptureLabelRequest" was null or undefined when calling setCaptureLabel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture/set-label`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetCaptureLabelRequestToJSON(requestParameters['setCaptureLabelRequest']),
        };
    }

    /**
     * Set Capture Label
     */
    async setCaptureLabelRaw(requestParameters: SetCaptureLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetCaptureLabelResponse>> {
        const requestOptions = await this.setCaptureLabelRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetCaptureLabelResponseFromJSON(jsonValue));
    }

    /**
     * Set Capture Label
     */
    async setCaptureLabel(requestParameters: SetCaptureLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetCaptureLabelResponse> {
        const response = await this.setCaptureLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCaptureLabel without sending the request
     */
    async updateCaptureLabelRequestOpts(requestParameters: UpdateCaptureLabelOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateCaptureLabelRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCaptureLabelRequest',
                'Required parameter "updateCaptureLabelRequest" was null or undefined when calling updateCaptureLabel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/capture-label/update`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCaptureLabelRequestToJSON(requestParameters['updateCaptureLabelRequest']),
        };
    }

    /**
     * Update Capture Label
     */
    async updateCaptureLabelRaw(requestParameters: UpdateCaptureLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCaptureLabelResponse>> {
        const requestOptions = await this.updateCaptureLabelRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCaptureLabelResponseFromJSON(jsonValue));
    }

    /**
     * Update Capture Label
     */
    async updateCaptureLabel(requestParameters: UpdateCaptureLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCaptureLabelResponse> {
        const response = await this.updateCaptureLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
